import { SPACING_16, SpacingVertical } from 'mailup-web-components'
import { searchState } from 'Pages/WorkflowStatistics/recoil/state/search'
import { useRecoilValue } from 'recoil'
import Results from './Results'
import Search from './Search'

const SearchRecipient = () => {
  const { totalItems } = useRecoilValue(searchState)

  return (
    <>
      <Search />
      {totalItems >= 0 && (
        <>
          <SpacingVertical variant={SPACING_16} />
          <Results />
        </>
      )}
    </>
  )
}

export default SearchRecipient
